import Vue from 'vue'
import Vuex from 'vuex'
import Axios from 'axios'
import VueAxios from 'vue-axios'
import VueSession from 'vue-session'
import Vuetify from 'vuetify'
import VueMoment from 'vue-moment'
import moment from 'moment-timezone'
import Vue2Filters from 'vue2-filters'
import VuetifyConfirm from 'vuetify-confirm'
import colors from 'vuetify/es5/util/colors'
import VueChartkick from 'vue-chartkick'
import Chart from 'chart.js'
import VueTransmit from 'vue-transmit'

import 'babel-polyfill'
import '@mdi/font/css/materialdesignicons.css'
import 'vuetify/dist/vuetify.css'
import '@/assets/style/app.sass'

import router from './router'
import store from './store'
import App from './components/App'

Vue.use(Vuex)
Vue.use(VueSession)
Vue.use(VueAxios, Axios)
Vue.use(VueMoment, { moment })
Vue.use(Vue2Filters)
Vue.use(VuetifyConfirm)
Vue.use(VueChartkick, {adapter: Chart})
Vue.use(VueTransmit)

Vue.use(Vuetify, {
  theme: {
    primary: '#0068b3',
    secondary: colors.blue.lighten1,
    accent: '#0068b3',
    error: colors.red.base,
    warning: colors.yellow.base,
    info: colors.blue.base,
    success: colors.green.base
  },
  iconfont: 'mdi',
  icons: {
    checkboxOn: 'check',
    radioOn: 'mdi-checkbox-blank-circle'
  }
})

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App },
  created () {
    if (this.$route.query.t) {
      this.$session.set('sessionToken', this.$route.query.t)
      store.commit('saveToken', this.$route.query.t)
    }

    this.axios.defaults.baseURL = process.env.API_URL
    this.axios.defaults.responseType = 'json'
    this.axios.defaults.headers.common['Accept'] = 'application/json'
    this.axios.defaults.headers.common['Content-Type'] = 'application/json'
    this.axios.defaults.headers.common['GUNGHO-ACCESS-TOKEN'] =
      this.$session.get('sessionToken')
  }
})



// WEBPACK FOOTER //
// ./src/main.js